import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'answerCard.uploadConfirmation.title',
    defaultMessage: 'ANSWER CARD LOADED',
  },
  subtitle: {
    id: 'answerCard.uploadConfirmation.subtitle',
    defaultMessage: '{amount} successful reply cards were uploaded!',
  },
  close: {
    id: 'answerCard.uploadConfirmation.close',
    defaultMessage: 'Close',
  },
});
